import { createContext, useContext, useLayoutEffect } from 'react'
import { Route } from '../../routes/Route'

interface PageContainerContextValue {
  /** Tells AppShell a page container is mounted; returns the unregister callback. */
  register: () => () => void
  /** Authorized route tree of the app, for building breadcrumbs and page titles. */
  routes: Route[]
  /**
   * On narrow screens the window scrolls as usual. On wider screens the app frame is fixed to the viewport
   * and pages scroll inside the content panel.
   */
  windowScroll: boolean
}

const PageContainerContext = createContext<PageContainerContextValue | null>(null)

export const PageContainerProvider = PageContainerContext.Provider

export const usePageContainerContext = () => useContext(PageContainerContext)

/**
 * Lets AppShell know the current page renders its own page container, so the shell drops its default
 * content padding and scrolling while the page is mounted.
 */
export const useRegisterPageContainer = () => {
  const context = useContext(PageContainerContext)

  // Layout effect, so the shell drops its padding before the first paint instead of shifting the page afterwards
  useLayoutEffect(() => context?.register(), [context?.register])
}
